export const distinctValues = (rows, dimension) => [
  ...new Set(rows.map(({ group }) => group[dimension]).filter((value) => !!value))
];
export const shareOfTotal = (tokens, { tokens: { total_tokens: totalTokens } }) => totalTokens > 0 ? tokens / totalTokens : void 0;
export const tokensPerRun = (totalTokens, runs) => runs > 0 ? Math.round(totalTokens / runs) : 0;
